import { createVenuesBaseClient } from './createAirTableClient';
import { distanceBetween } from './distance';
import { VENUE_LEADS_TABLE } from '../constants/airbase-tables';
import { captureError } from './monitoring';

export const getVenues = async ({ lat, lon }) => {
  try {
    const base = createVenuesBaseClient();

    const response = await base(VENUE_LEADS_TABLE)
      .select({
        view: 'Search View',
        maxRecords: 1000,
        filterByFormula: 'IF({Togather Worthy}, TRUE(), FALSE())',
      })
      .all();

    transformGetVenueResponse({ response, lat, lon });

    return transformGetVenueResponse({ response, lat, lon });
  } catch (error) {
    captureError(error);

    return [];
  }
};

export const transformGetVenueResponse = ({ response, lat, lon }) => {
  return response
    .map(({ fields }) => {
      // Split the location to get latitude and longitude values.
      const [venueLat, venueLon] = fields.Location.split(', ');

      // Calculate the distance between the input coordinates and the venue's coordinates.
      const distance = distanceBetween(
        lat,
        lon,
        Number(venueLat),
        Number(venueLon)
      );

      // Return the fields with an added distance property.
      return { ...fields, distance: distance };
    })
    .sort((a, b) => a.distance - b.distance); // Sort based on the calculated distance.
};
